import { render, staticRenderFns } from "./kpiEdit.vue?vue&type=template&id=5cc889fb&scoped=true"
import script from "./kpiEdit.vue?vue&type=script&lang=js"
export * from "./kpiEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc889fb",
  null
  
)

export default component.exports